import CityLandingPage from './page';

const sjcData = {
  cityName: 'São José dos Campos',
  state: 'SP',
  slug: 'palestra-silenciosa-sao-jose-dos-campos',
  coordinates: { lat: -23.1791, lng: -45.8872 },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa sao jose dos campos',
    'silent conference sjc',
    'aluguel fones sem fio vale do paraiba',
    'eventos corporativos sjc',
    'tradução simultânea sao jose dos campos',
    'festa silenciosa vale do paraiba',
  ],
  heroTitle: 'palestra silenciosa são josé dos campos',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos, conferências e workshops em São José dos Campos. Capital da indústria aeroespacial com suporte técnico de alto nível.',
  localStats: { clients: '70+', satisfaction: '99%' },
  localTestimonials: [],
  localFAQs: [
    { question: 'Vocês atendem todo o Vale do Paraíba além de São José dos Campos?', answer: 'Sim! Atendemos Jacareí, Taubaté, Caçapava, Pindamonhangaba e todo o Vale do Paraíba. Nossa equipe se desloca rapidamente para qualquer cidade da região com equipamentos completos.' },
    { question: 'Qual o prazo para contratar em São José dos Campos?', answer: 'Recomendamos 2 semanas para eventos padrão e 1 mês para grandes congressos. Temos flexibilidade para atender demandas urgentes em SJC, sempre sujeito à disponibilidade de agenda.' },
    { question: 'Os equipamentos funcionam bem nos centros de convenções de SJC?', answer: 'Perfeitamente! Já operamos no Parque Tecnológico, nos hotéis corporativos da região e em centros de convenções. O alcance de 100m sem obstáculos cobre confortavelmente qualquer salão em SJC.' },
    { question: 'Vocês têm experiência com eventos no setor aeroespacial e de defesa?', answer: 'Sim, temos vasta experiência com eventos corporativos de alto nível em SJC, incluindo o setor aeroespacial. Nossos equipamentos atendem aos mais rigorosos padrões de qualidade e confiabilidade.' },
    { question: 'Quantos fones sem fio estão disponíveis para São José dos Campos?', answer: 'Atendemos de pequenos workshops (25 fones) a grandes conferências (300+ fones) em SJC. Mantemos estoque estratégico na região para pronta-entrega e equipamentos de backup.' },
  ],
  seoTitle: 'São José dos Campos Palestra Silenciosa | Aluguel Fones SP | STIB',
  seoDescription: 'Palestra silenciosa São José dos Campos: aluguel de fones sem fio para eventos corporativos no Vale do Paraíba. Polo aeroespacial com tecnologia premium. Solicite orçamento!',
  relatedCities: [
    { name: 'São Paulo (Capital)', slug: '/sao-paulo', region: 'Capital' },
    { name: 'Campinas', slug: '/campinas', region: 'Região Metropolitana' },
    { name: 'Barueri / Alphaville', slug: '/barueri', region: 'Grande SP Oeste' },
    { name: 'Ribeirão Preto', slug: '/ribeirao-preto', region: 'Interior Norte' },
    { name: 'Santos', slug: '/santos', region: 'Baixada Santista' },
    { name: 'Guarulhos', slug: '/guarulhos', region: 'Grande SP Leste' },
    { name: 'São Bernardo do Campo', slug: '/sao-bernardo-do-campo', region: 'ABCD Paulista' },
    { name: 'Jundiaí', slug: '/jundiai', region: 'Interior Oeste' },
  ],
};

export default function SjcLandingPage() {
  return <CityLandingPage cityData={sjcData} />;
}